import slice from './App.slice';

const { reducer } = slice;
export { reducer as AppReducer };
export { saga as AppSaga } from './App.sagas';
